// extracted by mini-css-extract-plugin
export default {"row":"InfoModal_row__b-Xy8"};